import { STRATEGIES } from '#/shared/strategies';

export function supportsHedging(strategyCode: string) {
  const strategy = STRATEGIES[strategyCode];
  return strategy?.kind === 'OPTION';
}

export function getNumberOfHedges(strategyCode: string) {
  const strategy = STRATEGIES[strategyCode];
  if (strategy?.kind === 'FUTURE') {
    return 0;
  }

  const hedgeLegs = strategy?.hedgeLegs ?? [];
  return hedgeLegs.length;
}
